import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-action-dropdown-buttons',
  templateUrl: './action-dropdown-buttons.component.html',
  styleUrls: ['./action-dropdown-buttons.component.css']
})
export class ActionDropdownButtonsComponent implements OnInit {
  
  @Input() company:any;
  @Input() source:any;

  // sync
  @Output() customersSync = new EventEmitter<any>();
  @Output() employeeSync = new EventEmitter<any>();
  @Output() companiesSync = new EventEmitter<any>();
  @Output() servicesSync = new EventEmitter<any>();
  @Output() invoicesSync = new EventEmitter<any>();
  @Output() vendorsSync = new EventEmitter<any>();
  @Output() billsSync = new EventEmitter<any>();
  @Output() syncAll = new EventEmitter<any>();
  
  // invoices section
  @Output() sendEmai = new EventEmitter<any>();
  @Output() deleteInvoice = new EventEmitter<any>();
  @Output() downloadPdfInvoice = new EventEmitter<any>();

  // bills section
  @Input() canPay = false;
  @Output() deleteBill = new EventEmitter<any>();
  @Output() payBill = new EventEmitter<any>();

  // invoice payment section
  @Input() canReceivePayment = false;
  @Output() receivePayment = new EventEmitter<any>();

  @Input() invoice: any;
  @Input() customer: any;
  @Input() vendor: any;
  @Input() service: any;
  @Input() bill: any;
  @Input() billPayment: any;
  @Input() payment: any;
  @Input() employee: any;
  @Output() pullFrom = new EventEmitter<any>();
  @Output() pushTo = new EventEmitter<any>();
  @Output() voidPayment = new EventEmitter<any>();
  @Output() deleteBillPayment = new EventEmitter<any>();
  @Output() deletePayment = new EventEmitter<any>();
  
  // company
  @Output() attachCompnay = new EventEmitter<any>();
  @Output() deAttachCompnay = new EventEmitter<any>();
  
  constructor() { }

  ngOnInit() {

  }
}
